import React from 'react'
import AppBar from '../../components/AppBar'
import MarkFinalResultModalContainer from './MarkFinalResultModalContainer'

const MenuItem = ({ title, icon, onClick }) => (
  <button
    onClick={onClick}
    className="group relative w-full bg-white rounded-lg shadow-md hover:shadow-xl transition-all duration-300 hover:scale-105 p-8 min-h-[200px] flex flex-col items-center justify-center focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2"
  >
    <div className="mb-4 text-primary-600 group-hover:text-primary-700 transition-colors">
      {icon}
    </div>
    <h3 className="text-xl font-semibold text-gray-900 group-hover:text-primary-600 transition-colors text-center">
      {title}
    </h3>
  </button>
)

class MarkFinalServiceTxnScene extends React.Component {
  state = {
    type: undefined,
    isShow: false,
  }

  handleShowModal = (type) => {
    this.setState((state) => ({
      isShow: true,
      type,
    }))
  }

  handleHide = () => {
    this.setState((state) => ({
      isShow: false,
    }))
  }

  handleStartScanCompleted = () => {
    this.handleShowModal('completed')
  }

  handleStartScanNoShow = () => {
    this.handleShowModal('noShow')
  }

  handleStartScanMissedCase = () => {
    this.handleShowModal('missedCase')
  }

  render() {
    return (
      <div className="pt-20 px-4 md:px-8 w-full">
        <AppBar
          header="Quick Check"
          subHeader="update status of service transaction to final status"
          hasBtnGroup
        />
        <div className="py-8 max-w-7xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            <MenuItem
              title="Completed"
              onClick={this.handleStartScanCompleted}
              icon={
                <svg
                  className="w-16 h-16"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              }
            />
            <MenuItem
              title="No Show"
              onClick={this.handleStartScanNoShow}
              icon={
                <svg
                  className="w-16 h-16"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M10 14l2-2m0 0l2-2m-2 2l-2-2m2 2l2 2m7-2a9 9 0 11-18 0 9 9 0 0118 0z"
                  />
                </svg>
              }
            />
            <MenuItem
              title="Missed Case"
              onClick={this.handleStartScanMissedCase}
              icon={
                <svg
                  className="w-16 h-16"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke="currentColor"
                >
                  <path
                    strokeLinecap="round"
                    strokeLinejoin="round"
                    strokeWidth={2}
                    d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
                  />
                </svg>
              }
            />
          </div>
        </div>

        <MarkFinalResultModalContainer
          type={this.state.type}
          isShow={this.state.isShow}
          onHide={this.handleHide}
        />
      </div>
    )
  }
}

export default MarkFinalServiceTxnScene
